import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-background" >
{/* Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          {/* Back Button */}
          <Link to="/">
            <Button variant="ghost" className="mb-8 gap-2">
              <ArrowRight size={20} />
              العودة للرئيسية
            </Button>
          </Link>

          {/* Title */}
          <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            سياسة الخصوصية
          </h1>
          <p className="text-muted-foreground mb-8">آخر تحديث: {new Date().toLocaleDateString('ar-SA')}</p>

          {/* Content Sections */}
          <div className="bg-card rounded-2xl shadow-lg p-8 space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">مقدمة</h2>
              <p className="text-foreground leading-relaxed">
                نحن في العليمي لاستضافة المواقع نلتزم بحماية خصوصيتك وبياناتك الشخصية. 
                توضح هذه السياسة كيفية جمع واستخدام وحماية معلوماتك عند استخدام خدماتنا.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">المعلومات التي نجمعها</h2>
              <div className="space-y-4 text-foreground leading-relaxed">
                <p>نقوم بجمع المعلومات التالية:</p>
                <ul className="list-disc list-inside space-y-2 mr-6">
                  <li>معلومات الاتصال (البريد الإلكتروني، رقم الجوال)</li>
                  <li>معلومات الحساب والفوترة</li>
                  <li>معلومات الاستخدام والتفضيلات</li>
                  <li>معلومات تقنية (عنوان IP، نوع المتصفح)</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">كيف نستخدم معلوماتك</h2>
              <div className="space-y-4 text-foreground leading-relaxed">
                <p>نستخدم معلوماتك لـ:</p>
                <ul className="list-disc list-inside space-y-2 mr-6">
                  <li>توفير وتحسين خدماتنا</li>
                  <li>معالجة المعاملات وإرسال الفواتير</li>
                  <li>التواصل معك بخصوص حسابك</li>
                  <li>تحسين تجربة المستخدم</li>
                  <li>ضمان أمن وحماية خدماتنا</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">حماية بياناتك</h2>
              <p className="text-foreground leading-relaxed">
                نتخذ تدابير أمنية متقدمة لحماية بياناتك من الوصول غير المصرح به أو الاستخدام غير المشروع. 
                يتضمن ذلك التشفير، جدران الحماية، وفحص أمني منتظم.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">مشاركة البيانات</h2>
              <p className="text-foreground leading-relaxed">
                لن نقوم ببيع أو تأجير أو مشاركة بياناتك الشخصية مع أطراف ثالثة إلا في الحالات التالية:
              </p>
              <ul className="list-disc list-inside space-y-2 mr-6 text-foreground mt-4">
                <li>عند الحصول على موافقتك الصريحة</li>
                <li>للامتثال للمتطلبات القانونية</li>
                <li>لحماية حقوقنا وأمننا</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">حقوقك</h2>
              <div className="space-y-4 text-foreground leading-relaxed">
                <p>لديك الحق في:</p>
                <ul className="list-disc list-inside space-y-2 mr-6">
                  <li>الوصول إلى بياناتك الشخصية</li>
                  <li>تصحيح أي بيانات غير دقيقة</li>
                  <li>حذف بياناتك</li>
                  <li>إلغاء الاشتراك في الرسائل التسويقية</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-foreground mb-4">الاتصال بنا</h2>
              <p className="text-foreground leading-relaxed">
                إذا كان لديك أي أسئلة أو استفسارات بخصوص سياسة الخصوصية، يرجى التواصل معنا عبر:
              </p>
              <div className="mt-4 space-y-2">
                <p className="text-foreground">البريد الإلكتروني: info@alulaimihosting.com</p>
                <p className="text-foreground" dir="ltr">الهاتف: +966 50 123 4567</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
